import React, { FunctionComponent } from 'react';
import { UseFormMethods } from 'react-hook-form';
import { FormFieldTracking } from 'Interfaces/overlayTracking';
import useTranslate from 'Hooks/useTranslate';
import useSignupFormTracking from 'Hooks/useSignupFormTracking';
import { Step } from 'SharedComponents/styled/forms/Step';
import { PolicyWrapper } from 'SharedComponents/styled/forms/PolicyWrapper';
import { NewsletterErrorMsg } from 'SharedComponents/styled/forms/NewsletterErrorMsg';
import { NewsletterAdditionalInfo } from 'SharedComponents/styled/forms/NewsletterAdditionalInfo';
import { NewsletterActionWrapper } from 'SharedComponents/styled/forms/NewsletterActionWrapper';
import Radiobox from 'SharedComponents/Radiobox';
import { StepStatus } from 'Interfaces/StepStatus';

const StepTwo: FunctionComponent<{
    isLoading: boolean;
    status?: StepStatus;
    privacyPolicy: string;
    setIsSubscribed: (param: boolean) => void;
    formApi: UseFormMethods;
}> = ({ ...props }) => {
    const { tPlain } = useTranslate();
    const { trackPrivacyPolicyScroll, trackFieldChecked } = useSignupFormTracking();

    const onNewsletterAcceptClick = () => {
        props.setIsSubscribed(true);
        trackFieldChecked(FormFieldTracking.NewsletterAcceptFormField);
    };
    const onNewsletterNotAcceptClick = () => {
        props.setIsSubscribed(false);
        trackFieldChecked(FormFieldTracking.NewsletterNotAcceptFormField);
    };

    return (
        <>
            <input
                name="agb"
                type="hidden"
                value="1"
                className="qa-login-signup-form__agb gtm-login-signup-form__agb"
                ref={props.formApi.register()}
                defaultChecked
            />

            <Step className="qa-step qa-stepTwo gtm-step" status={props.status ?? StepStatus.PENDING}>
                <div>
                    <PolicyWrapper
                        onScroll={trackPrivacyPolicyScroll}
                        className="qa-login-signup-form__privacy-policy gtm-signup-overlay-mock__privacy-policy"
                        dangerouslySetInnerHTML={{ __html: props.privacyPolicy }}
                    />
                </div>
                <div>
                    <NewsletterErrorMsg className="qa-login-signup-form__generic-error--acceptance">
                        {props.formApi.errors?.subscribe?.message}
                    </NewsletterErrorMsg>
                    <NewsletterActionWrapper>
                        <Radiobox
                            id="acceptNewsletterSubscription"
                            className="gtm-register__privacy-policy-yes qa-register__privacy-policy-yes"
                            name="subscribe"
                            onClick={onNewsletterAcceptClick}
                            value="1"
                            usingRef={() =>
                                props.formApi.register({
                                    required: tPlain('signupOverlay_Select Accetto or Non Accetto'),
                                })
                            }
                            showError={!!props.formApi.errors.subscribe}
                            disabled={props.isLoading}
                        >
                            {tPlain('signupOverlay_I accept')}
                        </Radiobox>
                        <Radiobox
                            id="declineNewsletterSubscription"
                            className="gtm-register__privacy-policy-no qa-register__privacy-policy-no"
                            name="subscribe"
                            value="0"
                            onClick={onNewsletterNotAcceptClick}
                            usingRef={() =>
                                props.formApi.register({
                                    required: tPlain('signupOverlay_Select Accetto or Non Accetto'),
                                })
                            }
                            showError={!!props.formApi.errors.subscribe}
                            disabled={props.isLoading}
                        >
                            {tPlain('signupOverlay_I do not accept')}
                        </Radiobox>
                    </NewsletterActionWrapper>
                    <NewsletterAdditionalInfo>
                        {tPlain(
                            'signupOverlay_the treatment of my personal data to send the newsletter including access to the sales of Dalani via email.'
                        )}
                    </NewsletterAdditionalInfo>
                </div>
            </Step>
        </>
    );
};

export default StepTwo;
